module.exports = __webpack_public_path__ + "img/59.6c3107dd.jpg";